import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Context } from '../../../Context';
import { ReactComponent as IconChevron } from '../../../media/img/icon-chevron.svg';
import apart_styles from '../../../styles/aprt.module.scss';

function InfoBlockDescription() {
	const { activeApartmentData } = useContext(Context);

	const { t } = useTranslation();

	const [showDescription, setShowDescription] = useState(false);

	const descriptionText = activeApartmentData.description || '';

	if (!descriptionText || descriptionText.trim() === '') {
		return null;
	}

	return (
		// <div className={apart_styles.infoList_block}>
		// 	<div className={apart_styles.apartment_info_data_container}>
		// 		<div className={apart_styles.apartment_info_data_element}>
		// 			<span className={apart_styles.apartment_info_data_type}>{t('description')}</span>

		// 		</div>
		// 	</div>
		// </div>
		<div
			// -----------------------------  desc box  -----------------------------
			style={{
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				transition: 'max-height 800ms ease',
				overflow: 'hidden',
										marginTop: '1rem',

				maxHeight: showDescription ? '600px' : '56px', // 56px ≈ wysokość tylko nagłówka; dopasuj 600px do maksymalnej wysokości listy}
			}}
		>
			<div // ----------------------------- desc header -----------------------------
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					gap: '2.5rem',
					wrap: 'nowrap',
					paddingLeft: '0.5rem',
				}}
			>
				<span //h4?
					style={{
						display: 'inline-block',
						fontSize:' 1.2rem',
						fontWeight: '600',
						color: 'var(--color-headings)',
				}}
				>{t('description')}
				</span>

				{/* <CustomToolTip
						title={'Pokaż materiały dodatkowe do pobrania'}
						slots={{
							transition: Zoom,
						}}
						arrow
					> */}
				<button
					className={apart_styles.planButton}
					onClick={() => setShowDescription(!showDescription)}
				>
					<IconChevron
						title={"pokaż/ukryj opis"}
						className={apart_styles.planButton__icon}
						style={{
							transform: !showDescription ? 'rotate(90deg)' : 'rotate(-90deg)',
							transition: 'transform 300ms ease-in-out',
						}}
					/>
				</button>
				{/* </CustomToolTip> */}
			</div>
			{showDescription && (
				<div>
					<p className={apart_styles.apartment_info_data_paragraph}>
						{activeApartmentData.description ||
							'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'}
					</p>
				</div>
			)}
		</div>
	);
}

export default InfoBlockDescription;
